import HtmlContent from '@/components/elements/HtmlContent';
import Flyout from '@/components/Flyout';
import Image from '@/components/Image';
import ShareReferralLinks from '@/components/ShareReferralLinks';
import CMSContext from '@/contexts/CMSContext';
import { selectMgm } from '@/ducks/programs/mgm/selectors';
import { LEGAL_NAME, useLegalLinks } from '@/hooks/useLegalLink';
import { useAppSelector } from '@/store';

import PromotionBonusCard from '../PromotionBonusCard';
import ToggleDescriptionList from './ToggleDescriptionList';

import './HowItWorks.scss';

const HowItWorks = ({ isOpened, onClose, program = 'mgm', sailingData }) => {
  const mgm = useAppSelector(selectMgm);

  const contactUSLink = useLegalLinks(LEGAL_NAME.CONTACT_US);

  const referredBooker = program === 'celebrations' || mgm.isMgm;
  if (!referredBooker) return null;

  return (
    <Flyout className="PromotionHowItWorks-section" direction="right" onDismiss={onClose} open={isOpened}>
      <CMSContext.Consumer>
        {(cms) => (
          <section className="promotionHowItWorks">
            <PromotionBonusCard
              captionText={cms.get(`${program}.smallImage.metadata.caption`) || ''}
              cardInfoDescription={cms.get(`${program}.benefit.name`)}
              cardInfoHeader={cms.get(`${program}.headline`)}
              descriptionHeader={cms.get(`${program}.title`)}
              descriptionText={cms.get(`${program}.fullContent`)}
              imgSrc={cms.get(`${program}.smallImage.@link`)}
            />
            <section className="howItWorks__stepsBlock">
              <h1 className="stepsBlock__mainHeader">
                <HtmlContent content={cms.get(`${program}.legal.instructionalText`)} node="span" />
              </h1>
              <ul className="stepsBlock">
                {(cms.get(`${program}.legal.@nodes`) || []).map((nodeKey) => (
                  <li className="stepsBlock__item" key={nodeKey}>
                    <h2 className="stepsBlock__itemHeader">{cms.get(`${program}.legal.${nodeKey}.title`)}</h2>
                    <p className="stepsBlock__itemSubHeader">
                      <span dangerouslySetInnerHTML={{ __html: cms.get(`${program}.legal.${nodeKey}.body`) }} />
                    </p>
                    <Image
                      alt={cms.get(`${program}.legal.${nodeKey}.image.caption`) || ''}
                      aspectRatio={1}
                      bgImage
                      className="howItWorks__image"
                      src={cms.get(`${program}.legal.${nodeKey}.image.@link`)}
                    />
                  </li>
                ))}
              </ul>
            </section>
            <section className="questions">
              <article className="questions__head">
                <HtmlContent content={cms.get(`${program}.faqsTitle`)} node="p" />
                <HtmlContent content={cms.get(`${program}.faqsDescription`)} node="p" />
              </article>
              <ToggleDescriptionList className="questionsControls">
                {(cms.get(`${program}.faqs`) || []).map((item, i) => (
                  <ToggleDescriptionList.Item
                    className="questionsControls"
                    key={`flag-${i + 1}-${item.name}`}
                    num={i + 1}
                    text={item.answer}
                    title={item.name}
                  />
                ))}
              </ToggleDescriptionList>
              <article className="questions__banner">
                <div className="PromotionBonusModal__img">
                  <Image
                    alt={cms.get(`${program}.faqsFooterImage.metadata.caption`) || ''}
                    src={cms.get(`${program}.faqsFooterImage.@link`)}
                  />
                </div>
                <HtmlContent content={cms.get(`${program}.faqsFooterText`)} node="h2" />
              </article>
              <article className="questions__footer">
                <a
                  className="btn btn-block btn-secondary"
                  href={contactUSLink}
                  id="confirm_program_button"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {cms.get(`${program}.faqsCTALabel`)}
                </a>
                <p className="howItWorksTermsAndConditions">
                  <a href={cms.get(`${program}.termsAndConditionsLink`)} rel="noopener noreferrer" target="_blank">
                    <HtmlContent content={cms.get(`${program}.termsAndConditionsCTALabel`)} node="span" />
                  </a>
                </p>
              </article>
            </section>
            {sailingData && (
              <section className="shareLinks">
                <h2 className="shareLinks__title">
                  <HtmlContent content={cms.get(`${program}.shareTitle`)} node="span" />
                </h2>
                <p className="shareLinks__info">
                  <HtmlContent content={cms.get(`${program}.shareDescription`)} node="span" />
                </p>
                <ShareReferralLinks reservationNumber={sailingData.reservationNumber} />
              </section>
            )}
          </section>
        )}
      </CMSContext.Consumer>
    </Flyout>
  );
};

export default HowItWorks;
